import { entityJurisdictionItemModel } from '../entityJurisdictionItem';

/**
 * Transforms a list of entity jurisdictions from API
 * @param {Array<entityJurisdictionApiItem} data Jurisdiction data to transform
 * @returns {Array<entityJurisdictionItem} Transformed data
 */
export const getEntityJurisdictionsListModel = data =>
  data.map(jurisdiction => entityJurisdictionItemModel(jurisdiction));
